// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xo-1";
export var printerIcon = "_xo-0";